import { validate } from '@krugom/validator';
import store from '../../../store';
import { setCustomState } from '../../../store/reducer';
import { TValidationScheme } from '@krugom/validator/dist/types';

const setState = (arg?: any) => {
  const scheme: TValidationScheme = {
    type: 'object',
    properties: {
      name: { type: 'string', required: true },
    },
  };
  const result = validate(arg, scheme);

  if (result.isValid) store.dispatch(setCustomState(arg));
};

export default setState;
